export const selectStoredPinnedSearches = state => state.app.pinnedSearches
